exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".notificationSelector__container___EcPv- > span > span {\n  font-size: 11px;\n  font-weight: 800;\n  line-height: 2.73;\n  color: #292929;\n  text-transform: uppercase; }\n", ""]);

// exports
exports.locals = {
	"container": "notificationSelector__container___EcPv-"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/SavedSearchPage/ListSavedSearch/ListSavedSearchMobile/SavedSearchItem/NotificationSelector/notificationSelector.scss
// module id = 5044
// module chunks = 6